var map = {
	"./social-500px.svg": 153,
	"./social-dribbble.svg": 154,
	"./social-facebook.svg": 155,
	"./social-github.svg": 156,
	"./social-google.svg": 157,
	"./social-instagram.svg": 158,
	"./social-odnoklassniki.svg": 159,
	"./social-reddit.svg": 160,
	"./social-stackoverflow.svg": 161,
	"./social-steam.svg": 162,
	"./social-twitch.svg": 163,
	"./social-twitter.svg": 164,
	"./social-vkontakte.svg": 165,
	"./social-windows.svg": 166,
	"./social-wordpress.svg": 167,
	"./social-yahoo.svg": 168
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 152;


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/auth ^\.\/social\-.*\.svg$
// module id = 152
// module chunks = 0